














































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { GroupMessage, user, messageType } from '@/interfaces/websocketMessageInterfaces';

import moment from 'moment'
import { getAttachmentInfo } from '@/apis/common';
import { UploadFileIF } from '@/interfaces/types';
import { ImagePreview } from 'vant';
import { watch } from 'vue';

@Component({})
export default class ChatContent extends Vue {
  private messageType = messageType;
  @Prop() groupMessage!: GroupMessage;
  @Prop() userList!: Array<user>;


  private avatar = ''
  private type = 'user'
  private moment = moment;
  private file: UploadFileIF = {
    fileid: '', // 文件id
    ext: '', // 文件类型图小
    ext_s: '', // 文件类型图大
    ext_type: '', // 后缀
    size: '', // 文件大小
    name: '', // 文件名称
    url: '', // 文件下载地址
    date: '',
    rurl: '', // 文件预览地址
    isPic: 0, // 1是
  };
  private msgObj: any = {}

  // 全屏预览文件
  private fullScreenPreview: boolean = false;
  // 文件预览标题
  private FlagHead: boolean = true;

  viewImage() {
    ImagePreview([this.file.url])
  }

  openWindow(url: string, type = '_blank') {
    open(url, type);
  }

  mounted() {
    try {
      this.wsMsgModule.loginParam.uid === this.groupMessage.fromUid ? this.type = 'user' : this.type = 'other'
    } catch (e) {
      console.log(e);
    }
    this.userList.forEach(user => {
      if (user.uid === this.groupMessage.fromUid) {
        this.avatar = user.avatar || '';
      }
    })
    if (this.groupMessage.msgType !== 0 && this.groupMessage.msgType !== 10) {
      // 如果不是消息类型，就去获取文件信息
      if (this.groupMessage.msgContent || this.groupMessage.fileUrl) {
        getAttachmentInfo(this.groupMessage.fileUrl || this.groupMessage.msgContent).then(res => {
          this.file = res.info;
        }).catch(e => {
          console.log('getAttachmentInfo Error', e);
        })
      }
    }
    if (this.groupMessage.msgType === 10) {
      this.msgObj = JSON.parse(this.groupMessage.msgContent);
    }
  }

  // 去作业详情
  homeworkDetail() {
    const router = this.$router.resolve({
      path: '/homework',
      query: {
        courseId: this.msgObj.courseid,
        id: this.msgObj.homeworkid,
        courseRole: this.type === 'user' ? '1' : '0'
      }
    })
    window.open(router.href)
  }

  imageLoadSuccess(e: Event) {
    const img = e.target as HTMLImageElement;
    window.setTimeout(() => {
      if(img.complete) {
        img.removeAttribute('style')
      } else {
        this.imageLoadSuccess(e);
      }
    }, 200)
  }
}
